export default __webpack_public_path__ + "static/media/SWT0190.34I-27407_-16469_0.de3a9d5e.jpg";